<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="column">
    {{ data.message }}
  </div>
  <div fxLayout="column" class="loading-spinner">
    <mat-spinner [diameter]="20"></mat-spinner>
  </div>
</div>
